import { ToastrService as ngxToastrService, IndividualConfig } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})

export class ToastrService {
    private messages: any;

    // import required data for ngx toaster
    constructor(private toastr: ngxToastrService, private translate: TranslateService) {
        this.messages = this.translate.instant('toastr');
    }

    // Base functions from ngx Toastr Service
    show(message?: string, title?: string, override?: Partial<IndividualConfig>, type?: string) {
        this.toastr.show(message, title, override, type);
    }
    success(message?: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastr.success(message, title, override);
    }
    error(message?: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastr.error(message, title, override);
    }
    info(message?: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastr.info(message, title, override);
    }
    warning(message?: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastr.warning(message, title, override);
    }
    clear(toastId?: number) {
        this.toastr.clear(toastId);
    }
    remove(toastId: number) {
        this.toastr.remove(toastId);
    }
    findDuplicate(message: string, resetOnDuplicate: boolean, countDuplicates: boolean) {
        this.toastr.findDuplicate(message, resetOnDuplicate, countDuplicates);
    }
    // End Base functions from ngx Toastr Service

    showSuccess() {
        this.toastr.success(this.messages.success.message, this.messages.success.title,
            { timeOut: 3000, positionClass: 'toast-bottom-center', closeButton: true });
    }

    showError() {
        this.toastr.error(this.messages.error.message, this.messages.error.title,
            { timeOut: 3000, positionClass: 'toast-bottom-center', closeButton: true });
    }

    showInfo() {
        this.toastr.info(this.messages.info.message, this.messages.info.title,
            { timeOut: 3000, positionClass: 'toast-bottom-center', closeButton: true });
    }
}
